
const getWorkings = (workingsData) => workingsData.get('value');

export {getWorkings}